import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-vragen-vooraf',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-vragen-vooraf.component.html',
  styleUrl: './tekst-vragen-vooraf.component.scss',
})
export class TekstVragenVoorafComponent {}
